import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import enhanceWithActivity from 'hocs/enhanceWithActivity';
import enhanceWithPlugin from 'hocs/enhanceWithPlugin';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';

import {
  MenuListItem,
} from '@pearsontechnology/aero-components';

import messages from './messages';

import {
  MenuListItemText,
} from './CohortDeploymentListItem/styles';

function ActivityLink({ activityId, activity, pluginManifest, history }) {
  if (!activity || !pluginManifest) {
    return null;
  }

  return (
    <MenuListItem
      name='editActivity'
      onClick={() => history.push(`/${pluginManifest.type}/${activityId}`)}
    >
      <MenuListItemText>
        {intl.formatMessage(messages.editActivity, { activityType: pluginManifest.type })}
      </MenuListItemText>
    </MenuListItem>
  );
}

ActivityLink.propTypes = {
  activityId: PropTypes.string.isRequired,
  activity: PropTypes.object,
  pluginManifest: PropTypes.object,
  history: PropTypes.object,
};

const withActivity = enhanceWithActivity('activity', (props) => props.activityId);
const withPlugin = enhanceWithPlugin((props) => props.activity);

export default compose(
  withActivity,
  withPlugin,
  withRouter,
)(ActivityLink);
